<script>

    import { createEventDispatcher } from 'svelte'
    import { toast } from 'bulma-toast'
    import { LocationsStore } from '../stores'

    import LocationsService from '../$services/locations.service'
    import Select from '../$components/select.svelte'

    const dispatch = createEventDispatcher()

    export let location = {}

    let loading = false
    let query = {limit: 9999}

    getLocations()

    async function getLocations() {

        loading = true
        const resp = await LocationsService.getLocations(query)
        loading = false

        if(!resp.success) 
            return toast({message: resp.error.message, type: 'is-danger'})

        LocationsStore.set(resp.data.locations)
    }

    function onSelected(event) {
        const locationId = event.detail
        const item = $LocationsStore.find(location => location._id === locationId)
        location = {...item}
        dispatch('selected', location)
    }

</script>

{#if $LocationsStore.length}
    <Select on:change={onSelected} text="Mis direcciones" icon="address-book"
        options={$LocationsStore.map(location => {
            return {value: location._id, text: location.alias}
        })}
    />
{/if}